import { apiInstance } from 'api/utils';

export default {
  getMessages: (userId: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/ws/messages/${userId}/`
    }),
  markAsRead: (messageId: number) =>
    apiInstance.request({
      method: 'PUT',
      url: `/ws/messages/read/${messageId}/`
    }),
  deleteMessage: (messageId: number) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/ws/messages/read/${messageId}/`
    })
};
